import { DataTableColumnDef } from "@/components/molecules";
import { GuestPassengersTableData } from "./types";

export const guestPassengersColumns: DataTableColumnDef<GuestPassengersTableData>[] = [
  {
    accessorKey: "firstName",
    header: "First Name",
    id: "first_name",
    cell: (props) => props.row.original.firstName,
    size: 150,
  },
  {
    accessorKey: "lastName",
    header: "Last Name",
    id: "last_name",
    cell: (props) => props.row.original.lastName,
    size: 180,
  },
  {
    accessorKey: "contactNumber",
    header: "Contact Number",
    id: "phone",
    cell: (props) => props.row.original.contactNumber,
    size: 180,
  },
  {
    accessorKey: "emailAddress",
    header: "Email Address",
    id: "email",
    cell: (props) => props.row.original.emailAddress,
    size: 574,
  },
  {
    accessorKey: "action",
    header: "Action",
    id: "action",
    cell: (props) => props.row.original.action,
    size: 80,
    enableSorting: false,
  },
];
